import axios, { AxiosRequestConfig } from "axios";
import NativeClient from "@/client/native-client";
import store from "@/store";
import { AxiosError } from "axios";

/** Image Download クライアント */

const getImageDownloadClient = () => {
  if (process.env.VUE_APP_API_PATH == null) {
    /** API クライアント */
    return axios.create({
      headers: {
        'Content-type': 'application/octet-stream'
      },
      responseType: 'arraybuffer'
    });
  } else {
    /** API クライアント */
    return axios.create({
      withCredentials: false,
      headers: {
        'Content-type': 'application/octet-stream'
      },
      responseType: 'arraybuffer'
    });
  }
};

/** API実行時の共通処理 */
const requestFunc = async (config: AxiosRequestConfig) => {
  try {
    // headers に Store で保持した Access Token, APIキーを付与
    const apiBaseParams = store.getters["common/getApiBaseParams"];
    NativeClient.sendDebugLog("Image_Download_Client.ts requestFunc getApiParams completed");
    NativeClient.sendDebugLog("Image_Download_Client.ts requestFunc config = " + JSON.stringify(config));
    if (apiBaseParams.token != null && apiBaseParams.token != "") {
      NativeClient.sendDebugLog("Image_Download_Client.ts requestFunc token exist");
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${apiBaseParams.token}`
        }
      };
    } else {
      // token未設定(ログアウト状態)でAPIを実行
      NativeClient.sendDebugLog("Image_Download_Client.ts requestFunc token not exist");
      return {
        ...config,
        headers: {
          ...config.headers
        }
      };
    }
  } catch (error) {
    NativeClient.sendDebugLog("Image_Download_Client.ts requestFunc catch");
    NativeClient.sendDebugLog("Image_Download_Client.ts requestFunc catch error = " + error);
    NativeClient.sendDebugLog("Image_Download_Client.ts requestFunc catch error config = " + JSON.stringify(config));
    return config;
  }
};

/** API実行エラー時の共通処理 */
const responseErrorFunc = (error: AxiosError) => {
  const { response } = error;
  const { request } = error;
  const { code } = error;

  // エラー発生時は、loadingを止める
  store.dispatch("common/stopLoading");

  if (response && response.status == 401) {
    // ステータスコード 401（アクセストークン切れ）の場合は、Nativeにトークンのリフレッシュ要求
    // エラー発生中の場合は、トークンのリフレッシュ要求を行わない（トークンの多重リフレッシュの抑止のため）
    const apiError = store.getters["common/getApiError"];
    if (!apiError) {
      NativeClient.getRefreshToken();
    }
  }

  // エラー時処理
  if (response && response.status > 0 && response.data) {
    // サーバエラーが想定内のフォーマットの場合
    // Native側で処理しないならば、エラーを保持する
    if (!NativeClient.setAPIErrorState(response.status, response.data)) {
      store.dispatch("common/updatedApiError", response.data);
    }
  } else {
    // サーバエラーが想定外のフォーマットの場合
    // デフォルトのエラー設定
  }
  NativeClient.sendDebugLog("Image_Download_Client.ts responseErrorFunc code = " + JSON.stringify(code));
  NativeClient.sendDebugLog("Image_Download_Client.ts responseErrorFunc request = " + JSON.stringify(request));
  NativeClient.sendDebugLog("Image_Download_Client.ts responseErrorFunc response = " + JSON.stringify(response));
  return Promise.reject(error);
};
const imageDownloadClient = getImageDownloadClient();

imageDownloadClient.interceptors.request.use(requestFunc);
imageDownloadClient.interceptors.response.use(response => response, responseErrorFunc);

export default imageDownloadClient;

export const imageDownload = (id: number, imageUrl: string) => {
  NativeClient.sendDebugLog("imageDownload imageUrl=" + imageUrl);
  const apiBaseParams = store.getters["common/getApiBaseParams"];
  const promise = new Promise((resolve) => {
    const res = imageDownloadClient.get(imageUrl);
    resolve(res);
  });
  return promise;
};
